import { render, staticRenderFns } from "./ClassicInputEditor.vue?vue&type=template&id=b497600a&scoped=true&"
import script from "./ClassicInputEditor.vue?vue&type=script&lang=ts&"
export * from "./ClassicInputEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ClassicInputEditor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ClassicInputEditor.vue?vue&type=style&index=1&id=b497600a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b497600a",
  null
  
)

export default component.exports